import { Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { useSelector } from "react-redux";

Chart.register(...registerables);

const MultiLineChart = ({ graphData, selectedFilter }) => {
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);

  if (!graphData || graphData.length === 0) {
    return <div>No approved investments found for this portfolio...</div>;
  }

  // const labels = graphData.map((data) => {
  //   const date = new Date(data.date);
  //   const month = date
  //     .toLocaleString("default", { month: "short" })
  //     .toUpperCase();
  //   const year = date.getFullYear();
  //   return `${month}\n${year}`;
  // });

  const labels =
    graphData.length > 0
      ? graphData.map((item) => {
          const date = new Date(item.date);
          if (
            selectedFilter === "1M" ||
            selectedFilter === "1W" ||
            selectedFilter === "24H" ||
            selectedFilter === "CUSTOM"
          ) {
            const day = String(date.getDate()).padStart(2, "0");
            const month = date.toLocaleDateString("en-US", {
              month: "short",
            });
            return [day, month];
          } else {
            const month = date.toLocaleDateString("en-US", {
              month: "short",
            }); // e.g., "Jan"
            const year = date.getFullYear();
            return [month, year];
          }
        })
      : [];
  function hexToRGBA(hex, opacity) {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  const datasets = [
    {
      label: "Growth",
      data: graphData.map((data) => data.value),
      borderColor: "#8DAAE8",
      backgroundColor: hexToRGBA("#8DAAE8", 0.07),
      tension: 0.4,
      pointRadius: 4,
      pointHoverRadius: 6,
      pointBackgroundColor: "#8DAAE8",
      fill: true,
    },
    {
      label: "Net Investment",
      data: graphData.map((data) => data.total_invested),
      borderColor: "#ED7D31",
      backgroundColor: hexToRGBA("#ED7D31", 0.07),
      tension: 0.4,
      pointRadius: 4,
      pointHoverRadius: 6,
      pointBackgroundColor: "#ED7D31",
      fill: true,
    },
  ];

  const data = { labels, datasets };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false,
        external: function (context) {
          let tooltipEl = document.getElementById("chart-tooltip");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.id = "chart-tooltip";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.padding = "2px 8px";
            tooltipEl.style.borderRadius = "20px";
            tooltipEl.style.boxShadow = "0px 2px 6px rgba(0,0,0,0.2)";
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.transition = "opacity 0.3s";
            tooltipEl.style.opacity = "0";
            document.body.appendChild(tooltipEl);
          }

          const tooltipModel = context.tooltip;
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = "0";
            return;
          }

          if (tooltipModel.body) {
            const { dataIndex, datasetIndex } = tooltipModel.dataPoints[0];
            const dataset = context.chart.data.datasets[datasetIndex];
            const dataValue = dataset.data[dataIndex];
            const borderColor = dataset.borderColor;

            const date = new Date(graphData[dataIndex].date);
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure MM format
            const year = date.getFullYear();
            if (selectedFilter === "1M" || selectedFilter === "1W") {
              let d = date.getDate().toString().padStart(2, "0");
              tooltipEl.innerHTML = `<strong style="color: black;font-size: 12px;">${d}/${month}</strong>: <span style="color: ${borderColor}; font-size: 12px;">${cardCurrencyName.symbol}${dataValue
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>`;
            } else {
              tooltipEl.innerHTML = `<strong style="color: black;font-size: 12px;">${month}/${year}</strong>: <span style="color: ${borderColor}; font-size: 12px;">${cardCurrencyName.symbol}${dataValue
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>`;
            }
            tooltipEl.style.background = "rgba(255, 255, 255, 0.9)";
            tooltipEl.style.border = `1px solid ${borderColor}`;
          }

          const position = context.chart.canvas.getBoundingClientRect();
          tooltipEl.style.opacity = "1";
          tooltipEl.style.left =
            position.left + window.pageXOffset + tooltipModel.caretX + "px";
          tooltipEl.style.top =
            position.top + window.pageYOffset + tooltipModel.caretY - 30 + "px";
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          color: "#464646",
          padding: 10,
        },
        border: { display: true, color: "black" },
        min: 0,
      },
      y: {
        grid: { drawOnChartArea: true, drawTicks: false },
        ticks: {
          callback: (value) => `${cardCurrencyName.symbol}${value.toFixed(2)}`,
          color: "#464646",
          padding: 10,
        },
        beginAtZero: true,
        min: 0,
        border: { display: false },
      },
    },
  };

  return (
    <div className="w-full h-[400px] min-w-full">
      <Line data={data} options={options} />
    </div>
  );
};

export default MultiLineChart;
